import { cn } from "@design-system/utils";
import { Slot } from "@radix-ui/react-slot";
import * as React from "react";

function SidebarUserProfile({
  className,
  asChild = false,
  isActive = false,
  ...props
}: React.ComponentProps<"button"> & { asChild?: boolean; isActive?: boolean }) {
  const Comp = asChild ? Slot : "button";

  return (
    <Comp
      data-slot="sidebar-user-profile"
      data-sidebar="user-profile"
      data-active={isActive}
      className={cn(
        "bg-shape-neutral-ghost-background text-shape-neutral-ghost-foreground-default ring-ring-default hover:bg-shape-neutral-ghost-background-hover hover:text-shape-neutral-ghost-foreground-default-hover data-[state=open]:bg-shape-neutral-ghost-background-pressed data-[state=open]:text-shape-neutral-ghost-foreground-default-pressed data-[active=true]:bg-shape-neutral-ghost-background-pressed data-[active=true]:text-shape-neutral-ghost-foreground-default-pressed flex h-11 w-full items-center justify-start !gap-1 rounded-lg !py-0 py-2 !pr-0 pr-3 pl-2 text-left outline-hidden focus-visible:ring-3 data-[active=true]:font-medium [&>*]:pointer-events-none",
        className
      )}
      {...props}
    />
  );
}

function SidebarUserProfileInfo({
  className,
  ...props
}: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="sidebar-user-profile-info"
      data-sidebar="user-profile-info"
      className={cn("grid flex-1 text-left text-sm leading-tight", className)}
      {...props}
    />
  );
}

function SidebarUserProfileName({
  className,
  ...props
}: React.ComponentProps<"span">) {
  return (
    <span
      data-slot="sidebar-user-profile-name"
      data-sidebar="user-profile-name"
      className={cn("truncate", className)}
      {...props}
    />
  );
}

function SidebarUserProfileEmail({
  className,
  ...props
}: React.ComponentProps<"span">) {
  return (
    <span
      data-slot="sidebar-user-profile-email"
      data-sidebar="user-profile-email"
      className={cn(
        "text-foreground-neutral-muted truncate text-xs",
        className
      )}
      {...props}
    />
  );
}

export {
  SidebarUserProfile,
  SidebarUserProfileEmail,
  SidebarUserProfileInfo,
  SidebarUserProfileName,
};
